const defaultFlags = {
  ffEnableWsOptExportModifierReport: true,
  ffActiveConciliationBanner: true,
  ffValidateItemsAvailabilityByStore: true,
  ffEnableAverageTicketReport: true,
  ffEnableReportsVersion2: true,
  ffEnableProductsReportVersion2: true,
  ffHiddenLegacyReports: '{}',
};

export default defaultFlags;
